import { waitMillis } from "./ui";
import { get, set } from 'idb-keyval';

let ready = false;
let tokenSet = false;
const SHEET_CACHE_PREFIX = 'sheet-cache-v1';
const SHEET_READY_TIMEOUT_MS = 10000;
let sheetClientFailed = false;

var CLIENT_ID = '509165597934-hsubbplsho1o2n3epcru2s9tht2lgpar.apps.googleusercontent.com'; //'300551351829-d9p7f9ue3phb7r13v5lb6ehl44pmo5uj.apps.googleusercontent.com';
    var API_KEY = 'AIzaSyCysbC7CEIci1VLjCFJwWNrLqZx53eMmHM';

export async function initSheetClient(){
    if(!navigator.onLine){
        ready = true;
        return;
    }
    if(typeof gapi == 'undefined'){
        sheetClientFailed = true;
        return;
    }
    await gapi.load('client:auth2', internalInitSheetClient);
}

export async function setSheetToken(){
    if(tokenSet) return;
    await until(_ => ready == true);
    gapi.auth2.authorize({
        clientId: CLIENT_ID,
        response_type: 'permission', // Access Token.
        scope: 'https://www.googleapis.com/auth/spreadsheets'
     }, function(result) {
        if(!result.error) tokenSet = true;
     })
}

async function internalInitSheetClient(){


    // Array of API discovery doc URLs for APIs used by the quickstart
    var DISCOVERY_DOCS = ["https://sheets.googleapis.com/$discovery/rest?version=v4"];

    // Authorization scopes required by the API; multiple scopes can be
    // included, separated by spaces.
    var SCOPES = "https://www.googleapis.com/auth/spreadsheets.readonly" //"https://www.googleapis.com/auth/spreadsheets.readonly";
    /*;*/
     
    gapi.client.init({
            apiKey: API_KEY,
            clientId: CLIENT_ID,
            discoveryDocs: DISCOVERY_DOCS
          }).then(function () {
            console.log('loaded');
            ready = true;
            sheetClientFailed = false;
          // Listen for sign-in state changes.
        }, function(error) {
          //alert('Error signing in to sheet (make sure you are accessing from secure https:// URL)');
          console.log(error);
          sheetClientFailed = true;
        });
        console.log(gapi, 'Google')
    }

function until(conditionFunction, timeout = false) {
    let started = Date.now();
    const poll = resolve => {
        if(conditionFunction()) resolve(true);
        else if(timeout && Date.now() - started >= timeout) resolve(false);
        else setTimeout(_ => poll(resolve), 400);
    }
    
    return new Promise(poll);
}

function cacheKey(type, options){
    if(type == 'list') return `${SHEET_CACHE_PREFIX}:list:${options}`;
    return `${SHEET_CACHE_PREFIX}:${type}:${options.id}:${options.sheetName}:${options.startCol}:${options.endCol}`;
}

async function cachedSheetValue(type, options){
    let cached = await get(cacheKey(type, options));
    if(cached) return cached.value;
    return null;
}

async function cacheSheetValue(type, options, value){
    await set(cacheKey(type, options), {
        value,
        cachedAt: new Date().toISOString()
    });
}

async function waitUntilSheetReadyOrOffline(){
    if(!navigator.onLine) return false;
    if(sheetClientFailed) return false;
    let becameReady = await until(_ => ready == true || sheetClientFailed, SHEET_READY_TIMEOUT_MS);
    return becameReady && ready == true && !sheetClientFailed;
}

function convert(entry, options){
    let newEntry = {};
    let heads = options.headerConversion
    Object.keys(heads).forEach(h => {if(typeof heads[h] == 'object') newEntry[heads[h].root] = []});
    for(let k of Object.keys(entry)){
        Object.keys(heads).forEach(h => {
            if(h.toLowerCase().split('+').every(p => k.toLowerCase().includes(p))){
                if(typeof heads[h] == 'string'){
                    newEntry[heads[h]] = entry[k];
                }else if(typeof heads[h] == 'object'){
                    //newEntry[heads[h].root] = [];
                    heads[h].branches.forEach((b, i) => {   
                        //console.log('looking for '+b+' in '+k)
                        if(k.toLowerCase().includes(b.toLowerCase())){
                            //console.log('found '+b+' in '+k+' for '+newEntry.fname+' '+newEntry.sname+': '+entry[k])
                            newEntry[heads[h].root][i] = entry[k];
                        }
                    });
                }
            }
        });
    }
    return newEntry;
}

export async function listSheets(id){
    if(!await waitUntilSheetReadyOrOffline()){
        let cached = await cachedSheetValue('list', id);
        if(cached) return cached;
        return [];
    }
    let attempts = 3;
    let i = 0;
    while(i != attempts){
        try {
            let response = await gapi.client.sheets.spreadsheets.get({
                spreadsheetId: id
            });
            console.log(response.result);
            let list = response.result.sheets.filter(s => !s.properties.hidden).map(s => s.properties.title);
            await cacheSheetValue('list', id, list);
            return list;
        }catch(error){
            console.log(error);
            let cached = await cachedSheetValue('list', id);
            if(cached) return cached;
        }
        await waitMillis(100);
        i++;
    }
    
}

export async function loadSheets(options){
    if(!await waitUntilSheetReadyOrOffline()){
        let cached = await cachedSheetValue('values', options);
        if(cached) return cached;
        return [];
    }
    let attempts = 3;
    let i = 0;
    while(i != attempts){
        try{
            //let sheets = ['_i3Master', ]
            let response = await gapi.client.sheets.spreadsheets.values.get({
                spreadsheetId: options.id,
                range: options.sheetName+'!'+options.startCol+':'+options.endCol,
                majorDimension: 'ROWS',
              });
    
              var range = response.result;
              let headers = range.values.shift();
              let list = [];
              if(range.values.length == 0) return [];
            for (let i = 0; i < range.values.length; i++) {
                var row = range.values[i];
                let newEntry = {};
                for(let j = 0; j < row.length; j++){
                  newEntry[headers[j]] = row[j]; 
                }
                
                list = [...list, newEntry];//convert(newEntry, options)];
            }
            await cacheSheetValue('values', options, list);
            return list;
        }catch(error){
            console.log(error);
            let cached = await cachedSheetValue('values', options);
            if(cached) return cached;
            await waitMillis(200);
        }
        i++;
    }
    return [];
    
}

export async function loadRawSheets(options){
    // literally just the sheet values
    if(!await waitUntilSheetReadyOrOffline()){
        let cached = await cachedSheetValue('raw', options);
        if(cached) return cached;
        return [];
    }
    let attempts = 3;
    let i = 0;
    while(i != attempts){
        try{
            //let sheets = ['_i3Master', ]
            let response = await gapi.client.sheets.spreadsheets.values.get({
                spreadsheetId: options.id,
                range: options.sheetName+'!'+options.startCol+':'+options.endCol,
                majorDimension: 'ROWS',
              });
    
              var range = response.result;
              await cacheSheetValue('raw', options, range.values);
              return range.values;
        }catch(error){
            console.log(error);
            let cached = await cachedSheetValue('raw', options);
            if(cached) return cached;
            await waitMillis(200);
        }
        i++;
    }
    return [];
    
}

// In main head: <script on:load={initSheetClient} async defer src="https://apis.google.com/js/api.js"></script>

export async function setUpSheets(id, sheetTitles, data, format){
    await until(_ => ready == true);
    setSheetToken();
    await until(_ => tokenSet == true);
    let requests = [];
    let sheetFinder = Object.fromEntries(sheetTitles.map(t => [t, '']));


    try{
        //First make the sheet names right
        
        let response = await gapi.client.sheets.spreadsheets.get({
            spreadsheetId: id
        });
        console.log(id);
        let sheets = response.result.sheets;
        //console.log(response, sheets, sheetTitles);
        for(let i = 0; i < sheets.length; i++){
            // Rename ready for deletion
            requests.push({
                updateSheetProperties: {
                    properties: {
                        sheetId: sheets[i].properties.sheetId,
                        title: '__toDelete'+i
                    },
                    fields: 'title'
                }
            })
        }
        for(let i = 0; i < sheetTitles.length; i++){
            // If there are any left over, add extra sheets
            requests.push({
                addSheet: {
                    properties: {
                        title: sheetTitles[i]
                    }
                }
            });
        }
        for(let i = 0; i < sheets.length; i++){
            requests.push({
                deleteSheet: {
                    sheetId: sheets[i].properties.sheetId
                }
            });
        }

        let batchUpdateRequest = {requests};
   
        response = await gapi.client.sheets.spreadsheets.batchUpdate({
            spreadsheetId: id,
            resource: batchUpdateRequest
        });

        response = await gapi.client.sheets.spreadsheets.values.batchUpdate({
            spreadsheetId: id,
            valueInputOption: "USER_ENTERED",
            data
        });

        response = await gapi.client.sheets.spreadsheets.get({
            spreadsheetId: id
        });
        //console.log(id);
        sheets = response.result.sheets;
        for(let s of sheets){
            sheetFinder[s.properties.title] = s.properties.sheetId;
        }

        for(let f of format){
            for(let k of Object.keys(f)){
                if(f[k].range && f[k].range.sheetId) f[k].range.sheetId = sheetFinder[f[k].range.sheetId];
                if(f[k].dimensions && f[k].dimensions.sheetId) f[k].dimensions.sheetId = sheetFinder[f[k].dimensions.sheetId];
            }
        }

        //console.log(format)

        response = await gapi.client.sheets.spreadsheets.batchUpdate({
            spreadsheetId: id,
            resource: {requests: format}
        });

    }catch(error){
        console.log(error);
    }

}
